import React from "react";

import { AlgoliaModelMapper } from "@api/mappers/products.mapper";

import { useBreakpoint } from "@utils/breakpoints/breakpoints.provider";

import { AlgoliaTrackingService } from "@services/algolia/tracking/algoliaTracking.service";

import { ProductSearchTileRenditions } from "@components/Product/ProductImage/mappedRenditions";
import { ProductTileLayout } from "@components/Product/ProductTile/productTile.config";
import { ProductTile } from "@components/Product/ProductTile/productTile.container";
import { ResultListHitComponentProps } from "@components/Search/SearchResults/StateComponents/ResultList/resultList.container";
import { SearchResultProductTileConfig } from "@components/Search/SearchResults/searchResults.container";

import { ProductAlgoliaModel } from "../../../../../../@types/service/product/algolia/product.algolia.model";
import { useSearchHit } from "../searchHit.provider";

type ProductResultListHitComponentProps =
    ResultListHitComponentProps<ProductAlgoliaModel> & {
        productTileConfig?: SearchResultProductTileConfig;
    };

const ProductResultListHitComponent = ({
    hit,
    productTileConfig,
}: ProductResultListHitComponentProps) => {
    const product = AlgoliaModelMapper(hit);

    const { breakpoints } = useBreakpoint();
    const isMobile = !breakpoints.sm;

    const { queryID, position } = useSearchHit();

    const categoryLink = !!productTileConfig?.showCategoryLink;
    const button = !productTileConfig || productTileConfig?.showButton;

    const productTileComponents = (
        isMobile ? ProductTileLayout.PLP_HORIZONTAL : ProductTileLayout.PLP
    )(button, categoryLink);

    return (
        <ProductTile
            sku={product.sku}
            product={product}
            lazyLoadImage={productTileConfig?.lazyLoad || true}
            allowInstantAddToCart={
                productTileConfig?.allowInstantAddToCart || true
            }
            onClickTrack={() => {
                if (queryID) {
                    AlgoliaTrackingService.trackQuery(
                        queryID,
                        hit.sku,
                        position,
                    );
                }
            }}
            productTileConfig={{
                border: productTileConfig?.useInsidePadding || true,
                imageRenditions: ProductSearchTileRenditions,
                amountOfFeatures: productTileConfig?.amountOfFeatures ?? 4,
                hoverEffect: true,
                components: productTileComponents,
                ...(isMobile && { columnFractions: [5, 7] }),
            }}
            analyticsContext={{
                list: "product-search-results",
                placement: position,
            }}
        />
    );
};

export { ProductResultListHitComponent };
